import { FormSubmit } from '@kizi/comparator-components';
import { FormContext } from '@kizi/comparator-core';
import React, { useContext, useEffect, useState } from 'react';

export const FormSubmitWrapper = (props) => {
  const [disabled, setDisabled] = useState(false);
  const formContent = useContext(FormContext);

  useEffect(() => {
    const subscription = formContent.formService?.subscribe((s) => {
      if (
        s.event.type === 'CHANGE' &&
        s.event?.target?.name === 'currentProvider'
      ) {
        setDisabled(true);
      }
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, [formContent.formService]);

  return <FormSubmit {...props} disabled={disabled} />;
};
